import Api from '../utils/Api';

export const FETCH_INVITATIONS_REQUEST = 'FETCH_INVITATIONS_REQUEST';
export const FETCH_INVITATIONS_SUCCESS = 'FETCH_INVITATIONS_SUCCESS';
export const FETCH_INVITATIONS_FAILURE = 'FETCH_INVITATIONS_FAILURE';

export const ACCEPT_INVITATION_REQUEST = 'ACCEPT_INVITATION_REQUEST';
export const ACCEPT_INVITATION_SUCCESS = 'ACCEPT_INVITATION_SUCCESS';
export const ACCEPT_INVITATION_FAILURE = 'ACCEPT_INVITATION_FAILURE';

const fetchInvitationsRequest = () => ({
  type: FETCH_INVITATIONS_REQUEST
});

const fetchInvitationsSuccess = invitations => ({
  type: FETCH_INVITATIONS_SUCCESS,
  invitations
});

const fetchInvitationsFailure = () => ({
  type: FETCH_INVITATIONS_FAILURE
});

export const fetchInvitations = () => dispatch => {
  dispatch(fetchInvitationsRequest());
  return Api.getInvitations()
    .then(data => dispatch(fetchInvitationsSuccess(data)))
    .catch(error => dispatch(fetchInvitationsFailure(error)));
};

const acceptInvitationRequest = () => ({
  type: ACCEPT_INVITATION_REQUEST
});

const acceptInvitationSuccess = invitation => ({
  type: ACCEPT_INVITATION_SUCCESS,
  invitation
});

const acceptInvitationFailure = () => ({
  type: ACCEPT_INVITATION_FAILURE
});

export const acceptInvitation = invitationId => dispatch => {
  dispatch(acceptInvitationRequest());
  return Api.acceptInvitation(invitationId)
    .then(data => dispatch(acceptInvitationSuccess(data)))
    .catch(error => dispatch(acceptInvitationFailure(error)));
};



// WEBPACK FOOTER //
// ./src/actions/invitations.js